import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-md';
import { withRouter } from 'react-router-dom';
import { find } from 'lodash-es';

// import { DlpkContactCard } from '@coog/react-components';
// import { ContactForm } from './ContactForm';
import { ContactCard } from './ContactCard';

import { getIcon } from '../../NewQuotation/utils';
import {
  toMail,
  copyMail,
  subjectMail,
  getBodyMail,
  linkToForm,
  linkToEspace,
} from './config';

import * as productsActions from '../../../Services/Products/actions';

import './EmprunteurPlus.scss';

class EmprunteurPlus extends Component {
  componentDidMount() {
    const { actions, dateFormat } = this.props;
    actions.fetchCommercialProductsV2({ date: new Date(), dateFormat });
  }

  render() {
    const { pageHead, canonical, strings, theme, defaultWidgets, location, commercialProducts } = this.props;

    const onSubmit = values => {
      const mailTo = `mailto:${toMail}?subject=${encodeURIComponent(subjectMail)}&cc=${copyMail[theme.current]
        }&body=${encodeURIComponent(getBodyMail(values))}`;

      window.open(mailTo);
    };

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageHead] || pageHead}</title>
        <meta name="description" content={strings[pageHead] || pageHead} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const contactCard = find(defaultWidgets, {
      component: 'DlpkContactCard',
      conditions: [{ code: 'theme', value: theme.current }],
    });

    const locSplit = location?.pathname?.split?.('/') ?? [];
    const productName = locSplit?.[locSplit.length - 1] ?? '';
    const commProd = find(commercialProducts, { code: productName });

    return (
      <div className="coog-app emprunteurPlus">
        {helmet}
        <Grid className="coog-grid">
          <div className="header">
            {!!commProd && <div className="logo">{getIcon(commProd)}</div>}
            <div className="title">/ L'accès au meilleur de l'assureur emprunteur !</div>
          </div>
          <div className="content">
            <h1 className="md-title">La solution Emprunteur + by Nevidis</h1>
            <h2>Emprunteur + by Nevidis, c'est :</h2>
            <div className="step-1">
              <div className="full main">
                <p>
                  <b>Le service « clé-en-main » Emprunteur + by Nevidis</b> prend en charge l’accompagnement de vos
                  clients dans la proposition, la souscription et la substitution de leurs contrats d’assurances
                  emprunteurs tout en bénéficiant d’une rémunération différenciante composée de frais de dossiers et
                  d’une commission linéaire sur toute la durée de vie du contrat.
                </p>
                <p>Testez-le si ce n’est pas encore fait!</p>
                <div className="circles-pres">
                  <div className="circle-block 1">
                    <div className="header">Les +</div>
                    <div className="circle-wrapper">
                      <div className="circle">
                        <p>+ 50 contrats</p>
                        <p>Une entité spécialisée</p>
                        <p>Une information continue sur l'avancement des dossiers</p>
                      </div>
                    </div>
                  </div>
                  <div className="circle-block 2">
                    <div className="header">Bénéfices pour le client</div>
                    <div className="circle-wrapper">
                      <div className="circle">
                        <p>Un conseil juste et adapté</p>
                        <p>Un accompagnement continu</p>
                        <p>Une réelle expertise</p>
                      </div>
                    </div>
                  </div>
                  <div className="circle-block 3">
                    <div className="header">Bénéfices pour le partenaire</div>
                    <div className="circle-wrapper">
                      <div className="circle">
                        <p>Devenez acteur de l'assurance emprunteur</p>
                        <p>Un service accessible à tous et sans engagement</p>
                        <p>Une rémunération en frais de dossier pour chaque contrat amené</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {!!contactCard && (
                <div className="center contact-card">
                  <ContactCard
                    key={contactCard.config.key}
                    title={`BESOIN D'EN SAVOIR + ?`}
                    strings={strings}
                    emailContact={contactCard.config.emailContact}
                    phoneContact={contactCard.config.phoneContact}
                    scheduleContact={contactCard.config.scheduleContact}
                    theme={theme?.current}
                  />
                </div>
              )}
            </div>
            <h2>Emprunteur + by Nevidis, en 4 étapes :</h2>
            <div className="step-2">
              <div className="full main">
                <p>
                  <b>Comment ça marche ?</b>
                </p>
                <ol>
                  <li>Vous nous transmettez les coordonnées de votre Client</li>
                  <li>
                    Emprunteur + by Nevidis prend en charge votre Client, de la prise de contact initiale à la
                    souscription et la substitution
                  </li>
                  <li>Vous êtes informé en temps réel de l’avancée de chaque dossier (mail ou sms)</li>
                  <li>
                    Vous êtes rémunéré le mois qui suit la prise d’effet du contrat et pendant toute la vie du contrat.
                  </li>
                </ol>
                <b></b>
              </div>
            </div>
            <h1 className="md-title">Les coordonnées de votre Client</h1>
            <div className="step-3">
              <a
                href={theme?.current === 'nevidis' ? linkToForm?.nevidis : linkToForm?.nortia}
                className="linktoform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Transmettez-nous les coordonnnées de votre Client
              </a>
            </div>
            <h1 className="md-title">Le suivi des dossiers de vos clients</h1>
            <div className="step-4">
              <a
                href={linkToEspace}
                className="linktoform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Accédez à votre espace  Emprunteur + by Nevidis
              </a>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

EmprunteurPlus.propTypes = {
  pageHead: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  theme: PropTypes.object,
  defaultWidgets: PropTypes.array,
  dateFormat: PropTypes.string.isRequired,
  commercialproducts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
};

EmprunteurPlus.defaultProps = {
  pageHead: 'title.customer.emprunteur_plus.page',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  theme: {},
  defaultWidgets: [],
  commercialproducts: [],
};

const mapStateToProps = state => {
  const commercialProducts = state.toJS().products.commercialproductsV2.map(product => ({
    ...product,
    value: product.id,
    label: product.name,
    product: product.technical_product,
  }));

  return {
    defaultWidgets: state.get('dashboard').toJS()?.defaultWidgets ?? [],
    strings: state.toJS().quotations.strings,
    theme: state.get('theme').toJS(),
    commercialProducts,
    dateFormat: state.toJS().system.dateFormat,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...productsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmprunteurPlus));
